import * as S from "./InquiryContactItem.style";

interface InquiryPrivateItemProps {
  data?: any;
}

export const InquiryContactItem = ({ data }: InquiryPrivateItemProps) => {
  return (
    <S.InquiryPrivateItem>
      <S.InquiryPrivateTit $status={data.status}>
        <span>
          {data.status && data.status === "wait" ? "답변 대기중" : "답변 완료"}
        </span>
        {data.contactTitle}
      </S.InquiryPrivateTit>

      <S.InquiryPrivateContent>{data.contactcontent}</S.InquiryPrivateContent>

      {data.commentContent && (
        <S.AnswerContent>
          <span>A</span>
          {data.commentContent}
        </S.AnswerContent>
      )}
    </S.InquiryPrivateItem>
  );
};
